import React, { useCallback, useEffect, useMemo, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Col, Container, Row, Card, CardHeader, CardBody, Input, Label, Table, Button, Spinner, ButtonGroup, ButtonToggle } from "@/Components/ui";
;
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import moment from "moment";
import { API_PACKAGE, getDataFromUrl, BACKEND_HOST, API, addReservationItem } from "../../../api";
import { Calendar } from "react-calendar";
import Select from "react-select";
import { useAuthContext } from "../../../Components/AuthContext";
import { dialogService } from "@/utils/dialogService";
import {
    addOpenSeatSelection,
    buildReservationRequests,
    formatSelectedSpotNames,
    getSelectedSpotCount,
    removeOpenSeatSelection,
    toggleAssignedSeatSelection,
} from "./reservationSelection";
const ReservationAddItem = () => {
    const navigate = useNavigate();
    const { userInfo } = useAuthContext();
    const [spots, setSpots] = React.useState([]);
    const [selectedSpots, setSelectedSpots] = React.useState([]);
    const [phoneNum, setPhoneNum] = React.useState("");
    const [reservDate, setReservDate] = React.useState("");
    const [reservProduct, setReservProduct] = React.useState("");
    const [dateValue, setDateValue] = useState(new Date());
    const [reservLoading, setReservLoading] = useState(false);
    const [reservDatas, setReservDatas] = useState({});
    const [selectProducts, setSelectProducts] = useState([]);
    const [searchLoading, setSearchLoading] = useState(false);
    const [userSearch, setUserSearch] = React.useState("");
    const [userList, setUserlist] = React.useState([]);
    const [customerDisplayName, setCustomerDisplayName] = useState("");
    // const [userCount, setUserCount] = useState(0)
    // const [targetUser, setTargetUser] = useState(null)
    const [paidAmount, setPaidAmount] = useState(0);
    const [isNotify, setIsNotify] = useState(false);
    // useEffect(() => {
    // }, [userSearch])
    const searchUser = useCallback(() => {
        setSearchLoading(false);
        // console.log("parseInt(userSearch)", parseInt(userSearch))
        if (!userSearch) {
            setUserlist([]);
        }
        else {
            setSearchLoading(true);
            API.get(`${BACKEND_HOST}/accounts/users-crm?search=${userSearch}`)
                .then(async (res) => {
                console.log("search load:", res.data);
                if (res.data?.results)
                    setUserlist(res.data.results);
                else
                    await dialogService.handleAlert("search error...");
                setSearchLoading(false);
            })
                .catch(async (e) => {
                await dialogService.handleAlert(e, { force: "error" });
                setSearchLoading(false);
            });
        }
    }, [userSearch]);
    useEffect(() => {
        // Multiple spot selection - no need for single spot tracking
    }, [spots]);
    const targetDate = useMemo(() => {
        if (reservDate)
            return moment(reservDate, "YYYY-MM-DD").toDate();
        else
            return new Date();
    }, [reservDate]);
    useEffect(() => {
        setDateValue(targetDate);
        setSelectedSpots([]);
    }, [targetDate]);
    useEffect(() => {
        changeMonth(new Date());
    }, []);
    useEffect(() => {
        const _date = moment(dateValue).format("YYYY-MM-DD");
        if (!!reservDate || reservDate !== _date)
            setReservDate(_date);
    }, [reservDate, dateValue]);
    // useEffect(() => {
    //   setReservProduct(null);
    // }, [reservDate]);
    const changeMonth = (_target) => {
        setReservLoading(true);
        setDateValue(_target);
        // var lastDayOfMonth = new Date(_target.getFullYear(), _target.getMonth() + 1, 0);
        (async () => {
            const datas = await getDataFromUrl(`${API_PACKAGE}/status-montly/?year=${_target.getFullYear()}&month=${_target.getMonth() + 1}`);
            console.log(datas);
            if (datas && datas.result) {
                const _datas = {};
                for (let i = 0; i < datas.result.length; i++) {
                    _datas[datas.result[i][0]["date"]] = datas.result[i];
                }
                setReservDatas(_datas);
            }
            setReservLoading(false);
        })().catch((e) => {
            console.log(e);
        });
    };
    const [isSpotLoading, setIsSpotLoading] = useState(false);
    const abortController = useRef(null);
    useEffect(() => {
        API.get(`${BACKEND_HOST}/package/items/`)
            .then(({ data }) => {
            console.log("package products load:", data);
            setSelectProducts(data.filter((item) => {
                return item.min_date === 1 && item.max_date === 1;
            })
                .sort((a, b) => {
                if (a["상태"] !== b["상태"]) {
                    return a["상태"] > b["상태"] ? 1 : -1;
                }
                try {
                    return a["상품명"].localeCompare(b["상품명"]);
                }
                catch (e) {
                    return 0; // Fallback to no sorting if comparison fails
                }
            })
                .map((item) => {
                return { label: item["상품명"], value: item.id };
            }));
            // "id": 53,
            // "상품명": "테이블이용권",
        })
            .catch(async (e) => await dialogService.handleAlert(e, { force: "error" }));
    }, []);
    useEffect(() => {
        if (reservDate && reservProduct) {
            if (abortController.current)
                abortController.current.abort("AbortError");
            abortController.current = new AbortController();
            setIsSpotLoading(true);
            API.get(`${BACKEND_HOST}/package/items/?date=${reservDate}`, {
                signal: abortController.current.signal,
            })
                .then(({ data }) => {
                console.log("products spot load:", data);
                const _product = data.find((item) => {
                    return item.name === reservProduct;
                });
                if (_product && _product["spots"]) {
                    const availableOpenSeatCount = Math.max(Number(_product["count"] ?? 0) - Number(_product["reserved"] ?? 0), 0);
                    setSpots(_product["spots"].map((spot) => spot.is_free ? {
                        ...spot,
                        available_count: availableOpenSeatCount,
                    } : spot));
                }
                // {
                //     "id": 376,
                //     "name": "1",
                // }
            })
                .catch((e) => {
                if (e.name === "AbortError") {
                    console.log("Request aborted");
                }
                else {
                    console.log(e);
                }
            })
                .finally(() => {
                setIsSpotLoading(false);
            });
        }
        else {
            setSpots([]);
            setSelectedSpots([]); // Clear selected spots when no product is selected
        }
    }, [reservDate, reservProduct]);
    const addReservData = async () => {
        const dataList = await checkData();
        console.log("add", dataList);
        if (dataList === null || dataList.length === 0)
            return;
        if (selectedSpots.length > 1) {
            if (!await dialogService.confirm(`${selectedSpots.length}개의 자리를 모두 예약하시겠습니까?\n선택된 자리: ${formatSelectedSpotNames(selectedSpots)}`)) {
                return;
            }
        }
        Promise.all(dataList.map(data => addReservationItem(data)))
            .then(async (results) => {
            const successCount = results.filter(res => res?.result === "ok" || res?.id).length;
            if (successCount === dataList.length) {
                await dialogService.handleAlert(`${successCount}개의 예약이 모두 추가되었습니다!`);
            }
            else if (successCount > 0) {
                await dialogService.handleAlert(`${successCount}개의 예약이 추가되었습니다. ${dataList.length - successCount}개 실패.`);
            }
            else {
                await dialogService.handleAlert("예약 추가에 실패했습니다!");
            }
            history.go(0);
        })
            .catch(async (e) => {
            await dialogService.handleAlert("예약 추가 중 오류가 발생했습니다: " + e.message, { force: "error" });
            console.log(e);
        });
    };
    const checkData = async () => {
        if (!reservDate || !reservProduct || selectedSpots.length === 0) {
            await dialogService.handleAlert("필수 입력값이 없습니다.");
            return null;
        }
        let _phoneNum = phoneNum;
        if (!_phoneNum) {
            if (await dialogService.confirm("전화번호가 입력되지 않았습니다. 관리자 정보로 등록하시겠습니까?")) {
                _phoneNum = userInfo.phone_num;
            }
            else {
                await dialogService.handleAlert("전화번호를 입력해 주세요.");
                return null;
            }
        }
        // Return array of data for each selected spot
        const dataList = buildReservationRequests({
            phoneNum: _phoneNum,
            reservDate: reservDate,
            reservProduct: reservProduct,
            spots: selectedSpots,
            paidAmount: paidAmount,
            notifyUser: isNotify,
            customerDisplayName: customerDisplayName,
        });
        return dataList;
    };
    const clearAllSpots = () => {
        setSelectedSpots([]);
    };
    return (<React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title="예약 등록" pageTitle="예약"/>

          <Row className="g-4 mb-3">
            <div className="col-sm-auto">
              <div>
                <h4 className="card-title mb-0 flex-grow-1">예약 등록</h4>
              </div>
            </div>
            <div className="col-sm-3 ms-auto">
              <div className="d-flex justify-content-sm-end gap-2">
                <Button color="success" className="add-btn me-1" onClick={addReservData} id="create-btn">
                  예약 추가하기 ({selectedSpots.length}개 자리)
                </Button>
                <Button color="danger" className="add-btn me-1" onClick={() => {
            navigate(-1);
        }} id="cancel-btn">
                  Cancel
                </Button>
              </div>
            </div>
          </Row>

          <Row>
            <Col xxl={12}>
              <Card>
                <CardBody>
                  <div className="live-preview">
                    <Row>
                      <Col md={4}>
                        <div className="mb-3">
                          <Label htmlFor="phonenumberInput" className="form-label">
                            고객 전화번호
                          </Label>
                          <Input type="text" className="form-control" placeholder="고객정보를 검색해서 선택해 주세요" id="phoneNum" value={phoneNum} onChange={(e) => {
            setPhoneNum(e.target.value);
        }} maxLength="11" disabled/>
                          <div style={{ display: "flex", alignItems: "center", marginBottom: 20 }}>
                            <input onChange={(e) => {
            setUserSearch(e.target.value);
        }} id="search-bar-0" type="text" className="form-control search mt-1" style={{ width: "80%" }} placeholder={`Search User here...`} value={userSearch}/>
                            <Button onClick={() => {
            searchUser();
        }} color="soft-light" className="me-1 text-dark">
                              <i className="bx bx-search-alt search-icon"></i>
                            </Button>
                            <Button onClick={() => {
            setUserSearch("");
            setUserlist([]);
        }} color="soft-secondary" className="me-1">
                              <i className="bx bx-reset"></i>
                            </Button>
                          </div>
                          <div className="text-muted">
                            고객 전화번호를 입력하지 않으면 관리자 정보로 등록됩니다.
                          </div>
                        </div>
                      </Col>
                      <Col>
                        {searchLoading ? (<div style={{}}>
                            <Spinner color="primary"> Searching... </Spinner>
                          </div>) : null}
                        {!!userList &&
            userList.map((user, idx) => {
                if (idx > 4)
                    return null;
                return (<Button className="m-1" key={user.id} color="link" style={{ boxShadow: "none" }} onClick={() => {
                        setPhoneNum(user["전화번호"]);
                    }}>
                                <span>
                                  {user["이름"]} {user["전화번호"]}
                                </span>
                              </Button>);
            })}
                        <span>{!!userList && userList.length > 5 ? "..." : null}</span>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={4}>
                        <div className="mb-3">
                          <Label htmlFor="customerDisplayName" className="form-label">
                            표시 이름
                          </Label>
                          <Input type="text" className="form-control" placeholder="예약 목록에 표시할 이름" id="customerDisplayName" value={customerDisplayName} onChange={(e) => {
            setCustomerDisplayName(e.target.value);
        }} maxLength="50"/>
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={4}>
                        <div className="mb-3">
                          <Label htmlFor="firstNameinput" className="form-label">
                            예약날짜
                          </Label>
                          <Input type="text" className="form-control" placeholder="예약날짜" id="reservation-date" value={reservDate} onChange={(e) => setReservDate(e.target.value)} maxLength="11" disabled/>
                        </div>
                      </Col>
                      <Col>
                        {reservLoading ? (<div style={{}}>
                            <Spinner color="primary"> Loading... </Spinner>
                            <span>데이터를 로딩하는 중입니다...</span>
                          </div>) : (<React.Fragment>
                            <Calendar onChange={setDateValue} value={dateValue} calendarType="US" onClickMonth={(value) => {
                changeMonth(value);
            }} onActiveStartDateChange={({ action, activeStartDate, value, view }) => {
                console.log("Calendar onActiveStartDateChange:", action);
                if (view === "month") {
                    changeMonth(activeStartDate);
                }
            }} tileContent={({ activeStartDate, date, view }) => {
                const datestring = moment(date).format("YYYY-MM-DD");
                if (reservDatas[datestring]) {
                    return (<>
                                      {reservDatas[datestring].map((val, idx) => {
                            if (val.price)
                                return (<span key={idx} style={{ color: "#000" }}>
                                              <br />
                                              {`${val.name} (${val.reserved}/${val.count})`}
                                            </span>);
                            else
                                return (<span key={idx} style={{ color: "#888" }}>
                                              <br />
                                              <strike>{`${val.name} (${val.reserved}/${val.count})`}</strike>
                                            </span>);
                        })}
                                    </>);
                }
            }}/>
                          </React.Fragment>)}
                      </Col>
                    </Row>
                    <Row>
                      <Col md={4}>
                        <div>
                          <Label htmlFor="formFile" className="form-label">
                            예약상품
                          </Label>
                          {/* <Input type="text" className="form-control" placeholder="" id="reservation-product" value={reservProduct} onChange={(e) => (setReservProduct(e.target.value))} maxLength="100" disabled /> */}
                          <Select className="mb-0" 
    // defaultValue={selectProducts.find((val) => {
    //     return reservProduct === val.label
    // })}
    value={(() => {
            const _value = selectProducts.find((val) => {
                return reservProduct === val.label;
            });
            if (!_value)
                return null;
            else
                return _value;
        })()} onChange={(val) => {
            setReservProduct(val.label);
            // if (cellProps.row.original['예약상태'].valueOf() === val.value.valueOf()) return
            // changeReservationState(cellProps.row.original.id, val.value).then((data) => {
            //     console.log("changeReservationState", data)
            //     toast.success(`예약상태를 변경하였습니다!\n : ${cellProps.row.original['예약자']} ${cellProps.row.original['예약상태']}=>${val.value}`, {
            //         position: "top-right",
            //         autoClose: 5000,
            //         hideProgressBar: false,
            //         closeOnClick: true,
            //         pauseOnHover: true,
            //         draggable: true,
            //         progress: undefined,
            //         theme: "light",
            //     });
            // });
        }} options={selectProducts} id={"choices-single-reservation-product"}></Select>
                        </div>
                      </Col>
                    </Row>

                    <Row className="pt-2">
                      <Col md={4}>
                        <div>
                          <Label htmlFor="formFile" className="form-label">
                            선택된 자리번호 ({selectedSpots.length}개 선택됨)
                          </Label>
                          <div className="d-flex">
                            <Input type="text" className="form-control" placeholder="자리를 선택해주세요" id="spot" value={formatSelectedSpotNames(selectedSpots)} maxLength="100" disabled/>
                            {selectedSpots.length > 0 && (<Button className="ms-2" color="secondary" outline size="sm" onClick={clearAllSpots} title="모든 선택 해제">
                                <i className="bx bx-x"></i>
                              </Button>)}
                          </div>
                        </div>
                      </Col>
                      <Col>
                        {isSpotLoading ? (<div>
                            <div>데이터를 로딩중 입니다...</div>
                            <Spinner />
                          </div>) : (<div style={{ marginTop: "27px", display: "flex", flexWrap: "wrap", alignContent: "start", alignItems: "start", justifyItems: "start", justifyContent: "start", gap: "5px" }}>
                          {spots.map((spot, idx) => {
                const selectedCount = getSelectedSpotCount(selectedSpots, spot);
                const isSelected = selectedCount > 0;
                const openSeatLimit = Number(spot.available_count ?? 0);
                const isOpenSeatFull = spot.is_free && openSeatLimit > 0 && selectedCount >= openSeatLimit;
                return (<Button key={idx} id={`spot-checkbox-${idx}`} color={spot.is_able ? (isSelected ? "success" : "primary") : "danger"} outline={!isSelected} value={spot.name} onClick={() => {
                        if (spot.is_able) {
                            if (spot.is_free) {
                                if (!isOpenSeatFull) {
                                    setSelectedSpots(prev => addOpenSeatSelection(prev, spot));
                                }
                            }
                            else {
                                setSelectedSpots(prev => toggleAssignedSeatSelection(prev, spot));
                            }
                        }
                    }} disabled={!spot.is_able && spot.reason?.includes("reservation")} style={{
                        width: spot.is_free ? "72px" : "38px",
                        height: "38px",
                        padding: "0",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        fontSize: "14px",
                    }}>
                                <span>{spot.is_free ? `자유석 ${selectedCount ? `x${selectedCount}` : ""}` : spot.name}</span>
                              </Button>);
            })}
                          {spots.filter((spot) => spot.is_free && getSelectedSpotCount(selectedSpots, spot) > 0).map((spot) => (<Button key={`decrement-${spot.id}`} color="secondary" outline onClick={() => {
                setSelectedSpots(prev => removeOpenSeatSelection(prev, spot));
            }} style={{
                width: "38px",
                height: "38px",
                padding: "0",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                fontSize: "14px",
            }}>
                                <span>-</span>
                              </Button>))}
                        </div>)}
                        <div className="mt-2">
                          <small className="text-muted">
                            클릭하여 여러 자리를 선택/해제할 수 있습니다. 선택된 자리는 녹색으로 표시됩니다.
                          </small>
                        </div>
                      </Col>

                      <Row className="pt-2">
                        <Col md={4}>
                          <div>
                            <Label htmlFor="formFile" className="form-label">
                              결제금액
                            </Label>
                            <Input type="text" className="form-control" placeholder="결제금액" id="paid-amount" value={paidAmount} onChange={(e) => {
            setPaidAmount(e.target.value);
        }} maxLength="11"/>
                          </div>
                        </Col>
                      </Row>

                      <Row className="pt-2">
                        <Col>
                          <div className="mb-3">
                            <Label htmlFor="firstNameinput" className="form-label">
                              알림여부
                            </Label>
                            <div className="form-check form-check-inline">
                              <input className="form-check-input" type="radio" name="notify" id="notify-yes" value="true" checked={isNotify === true} onChange={(e) => {
            setIsNotify(true);
        }}/>
                              <label className="form-check-label" htmlFor="notify-yes">
                                예
                              </label>
                            </div>
                            <div className="form-check form-check-inline">
                              <input className="form-check-input" type="radio" name="notify" id="notify-no" value="false" checked={isNotify === false} onChange={(e) => {
            setIsNotify(false);
        }}/>
                              <label className="form-check-label" htmlFor="notify-no">
                                아니오
                              </label>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </Row>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>);
};
export default ReservationAddItem;
